import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";

export const Report: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.78656 4.55078C5.52373 4.55078 4.5 5.57451 4.5 6.83734V17.1608C4.5 18.4236 5.52373 19.4473 6.78656 19.4473H18.2134C19.4763 19.4473 20.5 18.4236 20.5 17.1608V6.83734C20.5 5.57451 19.4763 4.55078 18.2134 4.55078H6.78656ZM14.34 8.07523C13.9453 8.07523 13.6254 8.39514 13.6254 8.78978C13.6254 9.18441 13.9453 9.50433 14.34 9.50433H16.0719L13.234 12.3422L11.9218 11.03C11.6428 10.7509 11.1903 10.7509 10.9113 11.03L6.86595 15.0753C6.5869 15.3544 6.5869 15.8068 6.86595 16.0859C7.145 16.3649 7.59743 16.3649 7.87648 16.0859L11.4166 12.5458L12.7287 13.8579C13.0078 14.137 13.4602 14.137 13.7393 13.858L17.0825 10.5148V12.2468C17.0825 12.6415 17.4024 12.9614 17.797 12.9614C18.1917 12.9614 18.5116 12.6415 18.5116 12.2468V8.78978C18.5116 8.39514 18.1917 8.07523 17.797 8.07523H14.34Z"
      fill={color}
    />
  </svg>
);
